// require("./lib/pym");

require("./analytics");
var $ = require("./lib/qsa");
var track = require("./lib/tracking");

// ------ show more buttons ------ //
var showMoreClicked = 0; 

$(".ranking").forEach(function(ranking) {
	var button = $.one(".show-more", ranking); 
	var review = $.one(".review", ranking); 

	if (button) {
		review.classList.add("collapsed"); 
		button.addEventListener("click", function() {
			review.classList.toggle("collapsed"); 
			var collapsed = review.classList.contains("collapsed"); 
        	button.innerHTML = collapsed ? "Show me spoilers &#9660;" : "Show Less &#9650;";

        	// track when reviews get expanded
        	if (!collapsed) {
        		track("see full review", "season " + ranking.dataset.season);
        	};
		});
	};
});

// ------ category filters ------ //
var categoriesList = $.one("#categories"); 
var rankingsItems = Array.from(document.querySelectorAll(".ranking"));
var container = document.querySelector(".rankings-container");

var rankingsSlideSource = document.querySelector(".rankings-slide-source");

var rankingsGroups = Array.from(
  document.querySelectorAll("[data-rankings-group]")
);

var rankingsAdBreaks = Array.from(
  document.querySelectorAll("[data-rankings-ad-break]")
);

function updateDisplay() {
  // get category + checked state
  var selectedCategoryInput = document.querySelector(
    "input[name='categories']:checked"
  );

  // get sort type
  var sortTypeInput = document.querySelector(
    "input[name='sort']:checked"
  );

  var selectedCategory = selectedCategoryInput ? selectedCategoryInput.value : "all";
	var sortType = sortTypeInput ? sortTypeInput.value : "ranking";

  // start with a fresh copy so sort() does not mutate the master list
  var filtered = rankingsItems.slice();

  // filter
  if (selectedCategory != "all" && selectedCategory != "") {
    filtered = filtered.filter(item =>
      item.classList.contains(selectedCategory)
    );
  }

  // sort
  filtered.sort((a, b) => {
    if (sortType === "ranking") {
      return Number(b.dataset.ranking) - Number(a.dataset.ranking);
    } else {
      return Number(a.dataset.season) - Number(b.dataset.season);
    }
  });

  // Move all slides back to the hidden source bin and hide them.
  // This resets the visible layout before rebuilding it.
  rankingsItems.forEach(item => {
    item.classList.add("hide");
    rankingsSlideSource.appendChild(item);
  });

  // Hide all ad breaks to start.
  rankingsAdBreaks.forEach(adBreak => {
    adBreak.classList.add("hide");
  });

  // Redistribute visible slides into fixed groups of 5.
  filtered.forEach((item, index) => {
    var groupIndex = Math.floor(index / 5);
    var group = rankingsGroups[groupIndex];

    item.classList.remove("hide");
    group.appendChild(item);
  });

  // Show one ad break after every populated group.
  // This also gives you the "always one at the end" behavior.
  var populatedGroupCount = Math.ceil(filtered.length / 5);

  for (var i = 0; i < populatedGroupCount; i++) {
    rankingsAdBreaks[i].classList.remove("hide");
  }
}

categoriesList.onchange = function() {
	updateDisplay(); 

	track("change category", document.querySelector("input[name='categories']:checked").value)
	container.scrollIntoView({ behavior: "smooth"}); 
}

document.querySelectorAll("input[name='sort']").forEach(input => {
  input.addEventListener("change", () => {
  	updateDisplay(); 
  	track("change sort", document.querySelector("input[name='sort']:checked").value); 
	container.scrollIntoView({ behavior: "smooth"}); 
  });
});

// toggle functionality for category buttons
document.querySelectorAll("input[name='categories']").forEach((radio) => {
	radio.addEventListener("click", (e) => {
		if (e.target.dataset.wasChecked === "true") {
			e.target.checked = false; 
			e.target.dataset.wasChecked = "false"; 
			document.querySelector("#all").checked = true; 
			updateDisplay(); 
			container.scrollIntoView({ behavior: "smooth"}); 
		} else {
			document.querySelectorAll(`input[name="${e.target.name}"]`)
			.forEach(r => r.dataset.wasChecked = 'false');
      		e.target.dataset.wasChecked = 'true';
		}
	})
})

// check certain buttons on load
window.addEventListener('load', () => {
  document.querySelector("#ranking").checked = true;
  document.querySelector("#all").checked = true; 
  updateDisplay();
});

// ----- completion tracking -------- //

var slides = $(".sequence .slide").reverse();
var completion = 0; 

var onScroll = function() {
  for (var i = 0; i < slides.length; i++) {
    var slide = slides[i];    
    var bounds = slide.getBoundingClientRect();
    if (bounds.top < window.innerHeight * .9 && bounds.bottom > 0) {
      var complete = ((slides.length - i) / slides.length * 100) | 0;
      if (complete > completion) {
        completion = complete;
        track("completion", completion + "%");
      }
      // return activateSlide(slide);
    }
  }
}

window.addEventListener("scroll", onScroll);
onScroll();

// ----- add number suffixes -------- //
var rankingNums = document.querySelectorAll(".ranking-text"); 

// from here: https://stackoverflow.com/questions/13627308/add-st-nd-rd-and-th-ordinal-suffix-to-a-number
var returnSuffix = function(i) {
	var j = i % 10; 
	var k = i % 100; 

	if (j === 1 && k !== 11) {
		return "st"; 
	}

	if (j === 2 && k !== 12) {
		return "nd"; 
	}

	if (j === 3 && k !== 13) {
		return "rd"; 
	}

	return "th"; 
};

rankingNums.forEach(function(num) {
	// console.log(returnSuffix(num.textContent))
	var newSpan = document.createElement("span"); 
	newSpan.textContent = returnSuffix(num.textContent); 
	newSpan.classList.add("num-suffix"); 

	num.append(newSpan); 
});

window.addEventListener("load", function () {
  tp.experience.execute();
});